<template>
  <confirm-dialog ref="confirmDialog" />
</template>

<script>
import ConfirmDialog from "./ConfirmDialog.vue";
export default {
  name: "TenantSwitchDialog",
  components: { ConfirmDialog },
  props: {
    prevent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    ConfirmCompanyDialog,
    checkTenantName,
  },
};

async function checkTenantName() {
  const { tenantId } = this.$route.params;
  const { tenant } = this.$route.query;
  const actualTenantId = tenantId || tenant;
  const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
  if (users.some((u) => u.id === actualTenantId)) {
    if (
      String(this.tenantId).toLowerCase() !==
      String(actualTenantId).toLowerCase()
    ) {
      const answer = await this.ConfirmCompanyDialog();
      if (answer) {
        sessionStorage.setItem("tenantId", actualTenantId);
        localStorage.setItem("tenantId", actualTenantId);
        this.$router.go();
      } else {
        this.$router.push({ path: "/" });
      }
      return true;
    } else {
      return false;
    }
  } else {
    sessionStorage.removeItem("tenantId");
    localStorage.removeItem("tenantId")
    this.$auth.resetAllPermissions();
    this.$router.push({ path: "/forbidden" });
    return true
  }
}

async function ConfirmCompanyDialog() {
  const { tenantId } = this.$route.params;
  const { tenant } = this.$route.query;
  const actualTenantId = tenantId || tenant;
  const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
  let tenantName = "";
  const tenantData = users.find((u) => u.id === actualTenantId);
  if (tenantData) {
    tenantName = tenantData.name;
  }
  if (
    await this.$refs.confirmDialog.open(
      this.$t("lblSwitchCompany"),
      this.$t("msgSwitchCompany", { tenantName: tenantName }),
      { yesNoButtons: true }
    )
  ) {
    return true;
  }
}
</script>

<style>
</style>